import { Button } from "@/components/ui/button";
import * as Sentry from "@sentry/react";

export default function SentryExamplePage() {
  const triggerError = () => {
    throw new Error("Sentry Test Error - Configuration validée!");
  };

  const triggerCapturedError = () => {
    try {
      throw new Error("Test captured exception");
    } catch (e) {
      Sentry.captureException(e);
      alert("Erreur envoyée à Sentry!");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-2xl font-bold">Test Sentry</h1>
      <p className="text-muted-foreground">
        Cliquez sur un bouton pour envoyer une erreur à Sentry
      </p>
      
      <div className="flex gap-4">
        <Button onClick={triggerError} variant="destructive">
          Déclencher une erreur (crash)
        </Button>
        
        <Button onClick={triggerCapturedError} variant="outline">
          Capturer une exception (silencieux)
        </Button>
      </div>
    </div>
  );
}
